<template>
    <div>
        <v-app>
            <v-data-table :headers="headers" :items="extDataList" :items-per-page="5" :sort-desc="[false, true]" hide-default-footer class="paginated-table table-striped">
                <template v-slot:top>
                    <v-btn tile small color="success" @click="addExtendedProperty">
                        <v-icon left> mdi-plus</v-icon>
                        新增
                    </v-btn>
                </template>
                <template v-slot:item.variable_type="{ item }">{{ type_map[item.variable_type] }}</template>
                <template v-slot:item.option="{ item }">
                    <md-button class="md-just-icon md-success md-round md-simple" @click.native="editExtendedProperty(item)" style="padding-right: 30px;">
                        <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-just-icon md-danger md-round md-simple" @click.native="delExtendedProperty(index)">
                        <md-icon>close</md-icon>
                    </md-button>
                </template>
            </v-data-table>
            <v-dialog hide-overlay v-model="showExtDialog" max-width="600px">
                <v-app>
                    <v-form lazy-validation @submit.prevent="confirm">
                        <v-card class="window-card">
                            <v-card-title>
                                <span class="md-title" style="color: #67ad5b">扩展属性</span>
                            </v-card-title>
                            <v-card-text>
                                <v-text-field v-model="form.name" label="属性名称*" :rules="[v => !!v || '属性名称不能为空']"></v-text-field>
                                <v-select v-model="form.variable_type" :items="type_list" item-text="label" item-value="value" label="属性类型*" :rules="[v => !!v || '属性类型不能为空']"></v-select>
                                <v-text-field v-model="form.default_value" label="默认值" v-if="form.variable_type === 'string'"></v-text-field>
                                <v-text-field v-model="form.default_value" label="默认值" v-if="form.variable_type === 'int' || form.variable_type === 'float'"></v-text-field>
                                <v-select v-model="form.default_value" :items="form.ranges" label="默认值*" :rules="[v => !!v || '默认值不能为空']" v-if="form.variable_type === 'enum'"></v-select>
                                <div v-if="form.variable_type === 'bool'">
                                    <label style="margin-right: 15px;">默认值</label>
                                    <v-radio-group v-model="form.default_value">
                                        <v-radio label="true" value="true"></v-radio>
                                        <v-radio label="false" value="false"></v-radio>
                                    </v-radio-group>
                                </div>
                                <div class="md-layout" v-show="form.variable_type === 'int'">
                                    <label class="md-layout-item md-size-10 md-form-label" style="text-align: left"> 取值范围 </label>
                                    <div class="md-layout-item md-size-45">
                                        <v-text-field v-model="form.minIntValue" label="最小值"></v-text-field>
                                    </div>
                                    <div class="md-layout-item md-size-45" style="padding-right: 0px">
                                        <v-text-field v-model="form.maxIntValue" label="最大值"></v-text-field>
                                    </div>
                                </div>
                                <div class="md-layout" v-show="form.variable_type === 'float'">
                                    <label class="md-layout-item md-size-10 md-form-label" style="text-align: left"> 取值范围 </label>
                                    <div class="md-layout-item md-size-45">
                                        <v-text-field v-model="form.minFloatValue" label="最小值"></v-text-field>
                                    </div>
                                    <div class="md-layout-item md-size-45" style="padding-right: 0px">
                                        <v-text-field v-model="form.maxFloatValue" label="最大值"></v-text-field>
                                    </div>
                                </div>
                                <v-text-field v-model="form.ranges" label="取值范围" hint="请输入取值并回车..." v-show="form.variable_type === 'enum'"></v-text-field>
                                <v-combobox v-model="form.ranges" :items="claimDatas" hint="请输入取值并回车..." chips clearable multiple label="取值范围" v-show="form.variable_type === 'enum'">
                                    <v-chip v-bind="attrs" :input-value="selected" close @click="select" @click:close="remove(item)">
                                        <strong>{{ item }}</strong>
                                    </v-chip>
                                </v-combobox>
                                <v-text-field v-model="form.unit" label="单位"></v-text-field>
                                <v-text-field v-model="form.remark" label="备注"></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="success" type="submit">确定</v-btn>
                                <v-btn color="success" @click="showExtDialog = false">关闭</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-app>
            </v-dialog>
        </v-app>
    </div>
</template>
<script>
import { type_list } from './PropertyTypeList'

const type_map = type_list.reduce((pre, next) => {
    pre[next.value] = next.label
    return pre
}, {})

export default {
    name: 'ExtTab',
    props: {
        extDataList: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        'form.variable_type'() {
            this.form.default_value = ''
        }
    },
    data() {
        return {
            headers: [
                { text: '属性名称', align: 'center', value: 'name' },
                { text: '属性类型', align: 'center', value: 'variable_type' },
                { text: '默认值', align: 'center', value: 'default_value' },
                { text: '单位', align: 'center', value: 'unit' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            claimDatas: [], //自定义取值范围
            form: {},
            type_list,
            type_map,
            showExtDialog: false
        }
    },
    methods: {
        addExtendedProperty() {
            this.showExtDialog = true
            this.initForm()
        },
        editExtendedProperty(item) {
            this.form = item
            this.showExtDialog = true
        },
        delExtendedProperty(index) {
            this.$emit('remove', index)
        },
        confirm() {
            this.$emit('confirm', this.form)
            this.showExtDialog = false
        },
        initForm() {
            this.form = {
                type: 'add',
                name: '',
                remark: '',
                variable_type: '',
                default_value: '',
                unit: '',
                ranges: []
            }
        }
    }
}
</script>